import 'babel-polyfill'
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'

import deLocalization from './localization/deLocalization'
import frLocalization from './localization/frLocalization'
import itLocalization from './localization/itLocalization'
import enLocalization from './localization/enLocalization'

Vue.use(Vuex)
Vue.use(VueResource)

const store = new Vuex.Store({
  state: {
    userId: null,
    userAuthToken: null, // Authentication status depends on whether userAuthToken is null or not. If not null, then display stuff
    userCountry: 'CH', // This is hard-coded
    userLang: 'de',
    userStudyIdentifier: null,
    translatedStrings: {
      // en: enLocalization,
      de: deLocalization,
      it: itLocalization,
      fr: frLocalization
    },
    studyConsent: false,
    qnBuddyBotId: null
  },
  getters: {
    localization (state) {
      if (state.translatedStrings.hasOwnProperty(state.userLang)) {
        return state.translatedStrings[state.userLang]
      } else {
        return state.translatedStrings['de']
      }
    },
    authUrl (state) {
      return process.env.API_PROXY_URL + state.userId
    },
    matchUserToStudyUrl (state) {
      return process.env.API_QB_HOST + 'studies/matchuser-new/?study_name=' + process.env.STUDY_NAME + '&userid=' + state.userId + '&lang=' + state.userLang + '&country=' + state.userCountry
    },
    unmatchUserToStudyUrl (state) {
      return process.env.API_QB_HOST + 'studies/unmatchuser/?study_name=' + process.env.STUDY_NAME + '&userid=' + state.userId
    },
    checkUserMatchWithStudyUrl (state) {
      return process.env.API_QB_HOST + 'studies/user/?study_name=' + process.env.STUDY_NAME + '&userid=' + state.userId
    },
    getUserAnswerUrl (state) {
      // TODO: FormId should be a const
      return process.env.API_QB_HOST + 'answer/standard/?formid=' + process.env.STUDY_IDENTIFIER_FORMID + '&userid=' + state.userId
    },
    postUserAnswerUrl (state) {
      return process.env.API_QB_HOST + 'answer'
    },
    brazeAttributesUrl (state) {
      return process.env.API_DAILY_SERVICE_HOST + 'v1/braze/' + state.userId + '/attributes'
    },
    getBuddiesBotIdUrl (state) {
      return process.env.API_DAILY_SERVICE_HOST + 'v1/buddies/' + state.userId + '/find'
    }
  },
  mutations: {
    setUserLang: (state, payload) => {
      if (state.translatedStrings.hasOwnProperty(payload.userLang)) {
        state.userLang = payload.userLang
      } else {
        state.userLang = 'de'
      }
    },
    setUserProfile: (state, payload) => {
      state.userId = payload.userId
      state.userAuthToken = payload.userAuthToken
    },
    setStudyConsent: (state, payload) => {
      state.studyConsent = payload.studyConsent
    },
    setUserStudyIdentifier: (state, payload) => {
      state.userStudyIdentifier = payload.userStudyIdentifier
    },
    unsetStore: (state) => {
      state.userId = null
      state.userAuthToken = null
      state.userEmail = null
    },
    setQnBuddyBotId: (state, payload) => {
      state.qnBuddyBotId = payload.qnBuddyBotId
    }
  },
  actions: {
    fetchQnBuddyBotId ({ commit, state, getters }) {
      return new Promise((resolve, reject) => {
        Vue.http.get(getters.getBuddiesBotIdUrl).then((response) => {

          let userBotList = []
          response.body.result.forEach((bot) => {
            userBotList.push(bot.id)
          })

          // Get intersection between the two list
          let userQnBotList = userBotList.filter(element => process.env.QB_BOT_ID.includes(element))
          let userQnStudyBotList = userBotList.filter(element => process.env.QB_STUDY_BOT_ID.includes(element))

          if (process.env.NODE_ENV === 'production' && userQnBotList.length === 0) {
            Rollbar.critical('User is not friended with Qn Bot', state.userId)
          }

          let payload = { qnBuddyBotId: null }

          switch (userQnStudyBotList.length) {
            case 0:
              switch (userQnBotList.length) {
                case 0:
                  if (process.env.NODE_ENV === 'production') {
                    Rollbar.critical('User is not friended with Qn Bot', state.userId)
                  }
                  break
                default:
                  payload.qnBuddyBotId = Math.max(...userQnBotList)
                  break
              }
              break
            default:
              payload.qnBuddyBotId = Math.max(...userQnStudyBotList)
              break
          }

          let brazePayload = {
            'SQUAREQnBotId': payload.qnBuddyBotId
          }

          Vue.http.post(getters.brazeAttributesUrl, brazePayload).then(() => {},
            (error) => {
              Rollbar.error('Updating Braze attributes failed', error, getters.brazeAttributesUrl, brazePayload)
            })
          commit('setQnBuddyBotId', payload)
          resolve()
        }, (error) => {
          reject(error)
        })
      })
    },
    matchUser ({ commit, getters }) {
      return new Promise((resolve, reject) => {
        Vue.http.post(getters.authUrl + '?timestamp=' + new Date().getTime(), {}, {
          headers: {
            'request-url': getters.matchUserToStudyUrl
          }
        }).then((response) => {
          let payload = {
            studyConsent: true
          }
          commit('setStudyConsent', payload)
          resolve()
        }, (error) => {
          reject(error)
        })
      })
    },
    unmatchUser ({ commit, getters }) {
      return new Promise((resolve, reject) => {
        Vue.http.post(getters.authUrl + '?timestamp=' + new Date().getTime(), {}, {
          headers: {
            'request-url': getters.unmatchUserToStudyUrl
          }
        }).then(() => {
          // Note: no local update of study consent because you need to show the message
          // let payload = {studyConsent: false}
          // commit('setStudyConsent', payload)
          resolve()
        }, (error) => {
          reject(error)
        })
      })
    },
    updateUserProfile ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setUserProfile', payload)
        resolve()
      })
    },
    updateStudyConsent ({ commit, state, getters }) {
      return new Promise((resolve, reject) => {
        commit('setStudyConsent', true)
        resolve()
      })
    },
    checkUserIdentifier ({ commit, state, getters }) {
      return new Promise((resolve, reject) => {
        // cache-busting for IE11
        Vue.http.get(getters.authUrl + '?timestamp=' + new Date().getTime(), { headers: {
          'request-url': getters.getUserAnswerUrl
        }}).then((resp) => {
          let t = JSON.parse(resp.body)
          if (typeof (t.answer[process.env.STUDY_IDENTIFIER_QNID]) === 'undefined') {
            resolve()
          } else {
            commit('setUserStudyIdentifier', { userStudyIdentifier: t.answer[process.env.STUDY_IDENTIFIER_QNID].choice.label })
          }
          resolve()
        }, (error) => {
          if (error.status === 404) {
            resolve()
          } else {
            Rollbar.error('Error in fetching user endpoint', error)
            reject(error)
          }
        })
      })
    },
    checkStudyConsent ({ commit, state, getters }) {
      return new Promise((resolve, reject) => {
        Vue.http.get(getters.authUrl + '?timestamp=' + new Date().getTime(), { headers: {
          'request-url': getters.checkUserMatchWithStudyUrl
        }}).then((response) => {
          let b = JSON.parse(response.body)
          let payload = { studyConsent: b.matched }
          commit('setStudyConsent', payload)
          resolve()
        }, (error) => {
          // TODO: This 404 check should be removed when Yikun is done doing the updates
          if (error.status === 404) {
            resolve()
          } else {
            Rollbar.error('Failed resp for checkUserMatchWithStudyUrl endpoint', getters.checkUserMatchWithStudyUrl, error)
          }
          reject(error)
        })
      })
    },
    updateUserStudyIdentifier ({ commit, getters }, payload) {
      return new Promise((resolve, reject) => {
        Vue.http.post(getters.postUserAnswerUrl + '?timestamp=' + new Date().getTime(), payload).then((response) => {
          // FIXME: It's a bit crude to access the study identifier inside
          commit('setUserStudyIdentifier', { userStudyIdentifier: payload.form_response.answers[0].choice.label })
          resolve(response)
        }, (error) => {
          Rollbar.error('Failed posting answer', payload, getters.postUserAnswerUrl, error)
          reject(error)
        })
      })
    },
    updateUserLang ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setUserLang', payload)
        resolve()
      })
    },
    updateBrazeConsent ({ getters }, payload) {
      return new Promise((resolve, reject) => {
        let brazePayload = { 'squareConsent': payload }
        Vue.http.post(getters.brazeAttributesUrl, brazePayload).then(() => {
          resolve()
        }, (error) => {
          reject(error)
        })
      })
    },
    updateBrazeGender ({ getters }, payload) {
      return new Promise((resolve, reject) => {
        let brazePayload = { 'squareGender': payload }
        Vue.http.post(getters.brazeAttributesUrl, brazePayload).then(() => {
          resolve()
        }, (error) => {
          reject(error)
        })
      })
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js